import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
/* import '@/permission.js' */
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import configHttp from '../configHttp.js';
import {
    messages
} from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/icon.css';
import '../directives.js';

Vue.prototype.baseURL = configHttp.baseURL; //  后台请求地址
Vue.config.productionTip = false;
Vue.use(VueI18n);
ElementUI.TableColumn.props.showOverflowTooltip = { type: Boolean, default: true };
Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});
import taxui from 'tax-ui';

Vue.use(taxui);

// 费用进件渠道
Vue.prototype.sourceTypes = [
    {
        value: '1',
        label: '扫描仪'
    },
    {
        value: '2',
        label: '邮件'
    }
];

// 费用类型
Vue.prototype.feeTypes = [
    {
        value: 'MM',
        label: 'MM'
    },
    {
        value: 'FI',
        label: 'FI'
    },
    {
        value: 'TE',
        label: 'TE'
    }
];

Vue.prototype.feeTypeList = [
    { value: '-1', label: '无' },
    {
        value: 'MM',
        label: 'MM'
    },
    {
        value: 'FI',
        label: 'FI'
    },
    {
        value: 'TE',
        label: 'TE'
    }
]

// 费用是否提交主流程
Vue.prototype.submitStatus = [
    {
        value: '0',
        label: '否'
    },
    {
        value: '1',
        label: '是'
    }
];

// 费用批次合并状态
Vue.prototype.mergeStatus = [
    {
        value: '0',
        label: '未合成'
    },
    {
        value: '1',
        label: '待手工合并'
    },
    {
        value: '2',
        label: '已合并'
    }
];

// 费用批次验票成功状态
Vue.prototype.collectionInspStatus = [
    {
        value: '0',
        label: '否'
    },
    {
        value: '1',
        label: '是'
    }
];

//录入发票类型
Vue.prototype.invoiceTypes = [
    {
        value: '007',
        label: '增值税普票'
    },
    {
        value: '004',
        label: '增值税专票'
    },
    {
        value: '026',
        label: '增值税普票(电子)'
    },
    {
        value: '028',
        label: '增值税专票(电子)'
    },
    {
        value: '620',
        label: '全电发票(电子普通)'
    },
    {
        value: '820',
        label: '全电发票(电子专票)'
    },
    {
        value: '701',
        label: '外币'
    },
    {
        value: '012',
        label: '海关缴款书'
    },
    {
        value: '901',
        label: '收据'
    },
    {
        value: '000',
        label: '其他类'
    },
    {
        value: '005',
        label: '机动车销售发票'
    },
    {
        value: '702',
        label: 'Debit Note'
    },
    {
        value: '703',
        label: 'Credit note'
    }
];
Vue.prototype.taxRates = [
    {
        value: '0',
        label: '0%'
    },
    {
        value: '0.01',
        label: '1%'
    },
    {
        value: '0.03',
        label: '3%'
    },
    {
        value: '0.05',
        label: '5%'
    },
    {
        value: '0.06',
        label: '6%'
    },
    {
        value: '0.08',
        label: '8%'
    },
    {
        value: '0.09',
        label: '9%'
    },
    {
        value: '0.1',
        label: '10%'
    },
    {
        value: '0.11',
        label: '11%'
    },
    {
        value: '0.12',
        label: '12%'
    },
    {
        value: '0.13',
        label: '13%'
    },
    {
        value: '0.16',
        label: '16%'
    },
    {
        value: '0.17',
        label: '17%'
    }

];
Vue.prototype.invoiceInspStatus = [
    {
        value: '2',
        label: '待验票'
    },
    {
        value: 'd01',
        label: '查验一致'
    },
    {
        value: '6',
        label: '查验失败'
    },
    {
        value: 'd02',
        label: '发票作废'
    },
    {
        value: 'd03',
        label: '信息不一致'
    },
    {
        value: 'd04',
        label: '查无此票'
    },
    {
        value: 'd05',
        label: '发票红冲'
    },
    {
        value: '3',
        label: '请求参数错误'
    },
    {
        value: '002',
        label: '暂不支持的发票类型'
    },
    {
        value: '4',
        label: '验票中'
    },
    {
        value: '7',
        label: '人工查验成功'
    },
    {
        value: '8',
        label: '无需验票'
    }
];

//  EDI推送状态：0-未推送 1-已推送
Vue.prototype.ediPushStatus = [
    {
        value: '0',
        label: '未推送'
    },
    {
        value: '1',
        label: '已推送'
    }
];

//  流程节点：0-待SAP凭证反写 1-待审核 2-待发票认证 3-处理完成
Vue.prototype.processNodeList = [
    {
        value: '0',
        label: '待SAP凭证反写'
    },
    {
        value: '1',
        label: '待审核'
    },
    {
        value: '2',
        label: '待发票认证'
    },
    {
        value: '3',
        label: '处理完成'
    }
]

//  发票认证-是否勾选：0-否 1-是
Vue.prototype.certificationStatusList = [
    {
        value: '0',
        label: '否'
    },
    {
        value: '1',
        label: '是'
    }
]

//  反写结果
Vue.prototype.sapReverseResultList = [
    {
        value: '1',
        label: '返写成功'
    },
    {
        value: '2',
        label: '条码不存在'
    },
    {
        value: '3',
        label: '条码已返写'
    },
    {
        value: '4',
        label: '条码与入账公司不符'
    },
    {
        value: '5',
        label: '流程节点有误'
    }
];

  

Vue.prototype.numtofapiao = function(stirng) { //类型代号转文字
    if (stirng == '028') {
        return '电子专用发票';
    } else if (stirng == '004') {
        return '纸质专票';
    } else if (stirng == '007') {
        return '纸质普票';
    } else if (stirng == '026') {
        return '电子普通发票';
    } else if (stirng == '000') {
        return '其它';
    }
},
Vue.prototype.checkStatustoString = function(yanpzt) { //类型代号转文字
    var yanpztStr = '';
    switch (yanpzt) {
        case '8'  :
            yanpztStr = '无需验票';
            break;
        case '7'  :
            yanpztStr = '手工置为验票成功';
            break;
        case '2'  :
            yanpztStr = '待验票';
            break;
        case '3'  :
            yanpztStr = '请求参数错误';
            break;
        case '000':
        case '0'  :
            yanpztStr = '待验票';
            break;
        case '5'  :
        case 'd01':
            yanpztStr = '查验一致';
            break;
        case '6'  :
        case 'd06':
        case 'd05':
        case 'd07':
        case 'd04':
        case 'd08':
        case 'd09':
        case 'd11':
        case 'd12':
        case 'd13':
        case 'd14':
        case 'd10':
            yanpztStr = '查验失败';
            break;
        case '4':
            yanpztStr = '验票中';
            break;
        case 'd02':
            yanpztStr = '发票作废';
            break;
        case 'd03':
            yanpztStr = '信息不一致';
            break;
        case '002':
            yanpztStr = '暂不支持的发票类型';
            break;
        default:
            yanpztStr = '查验失败';
            break;
    }
    return yanpztStr;
}
Vue.prototype.fplistall = [
    {
        value: '2',
        label: '待验票'
    },
    {
        value: 'd01',
        label: '查验一致'
    }
];
Vue.prototype.cpylist = [
    {
        value: '0',
        label: '否'
    },
    {
        value: '1',
        label: '是'
    },
    {
        value: '6',
        label: '查验失败'
    },
    {
        value: 'd02',
        label: '发票作废'
    },
    {
        value: 'd03',
        label: '信息不一致'
    },
    {
        value: '3',
        label: '请求参数错误'
    },
    {
        value: '002',
        label: '暂不支持的发票类型'
    },
    {
        value: '4',
        label: '验票中'
    },
    {
        value: '7',
        label: '人工查验成功'
    },
    {
        value: '8',
        label: '无需验票'
    }
];
Vue.prototype.statslist = [
    {
        label: '处理中',
        status: '1'
    },
    {
        label: '导入成功',
        status: '2'
    },
    {
        label: '导入失败',
        status: '-1'
    }
];
Vue.prototype.parseStatusList = [
    {
        label: '成功',
        value: '1'
    },
    {
        label: '失败',
        value: '-1'
    },
    {
        label: '处理中',
        value: '2'
    },
]
Vue.prototype.diagheightzhengshutiankai = function() {
    if (window.innerHeight > 850) {
        return 570;
    } else {
        return window.innerHeight - 300;
    }
};
Vue.prototype.diagheightshenghe = function() {
    if (window.innerHeight > 850) {
        return 570;
    } else {
        return window.innerHeight - 300;
    }
};
Vue.prototype.notemptyandnull = function(stirng) {
    if (stirng != '' & stirng != null) {
        return true;
    } else {
        return false;
    }
},
Vue.prototype.emptyandnull = function(stirng) {
    if (stirng == '' || stirng == null) {
        return true;
    } else {
        return false;
    }
},
Vue.prototype.diagheight = function(status) {

    if (window.innerHeight > 850) {
        if (status) {
            return 630;
        }
        return 570;

    } else {
        if (status) {
            return window.innerHeight - 240;
        }
        return window.innerHeight - 300;
    }
};
Vue.prototype.stringtostmp = function(string) { //后台格式转日期
    if (string != '' & string != null) {
        if (string.length < 14) {
            return string.substring(0, 4) + '年' + string.substring(4, 6) + '月' + string.substring(6, 8) + '日';
        }
        var alllist = string.split('');
        var tmp = alllist[0] + alllist[1] + alllist[2] + alllist[3] + '年' + alllist[4] + alllist[5] + '月' + alllist[
                6] + alllist[7] + '日' + ' ' + alllist[8] + alllist[9] + '时' + alllist[10] + alllist[11] + '分' +
            alllist[12] + alllist[13] + '秒';

        return tmp;
    } else {
        return '';
    }
},
Vue.prototype.yyyyMMdd = function(value) {
    if (value === undefined || value === null || value === '') {
        return '';
    }

    if (value.length < 8) {
        return '';
    }

    return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8);
},
Vue.prototype.timestampToStr = function(date) {
    if (date == null || date == '') {
        return '';
    }
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + '';
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return YY + MM + DD + ' ' + hh + mm + ss;
},
Vue.prototype.timestampToStrmm = function(date) {
    if (date == null || date == '') {
        return '';
    }
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);

    return YY + MM;
},
Vue.prototype.timestampToStrss = function(date) {
    if (date == null || date == '') {
        return '';
    }
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return YY + MM + DD + hh + mm + ss;
},
Vue.prototype.typetostr = function(type) {
    if (type == '0') {
        return '金税盘';
    } else if (type == '1') {
        return '税控盘';
    } else if (type == '2') {
        return '税务UKEY';
    }

},
Vue.prototype.numtofapiao = function(stirng) { //类型代号转文字
    if (stirng == '028') {
        return '电子专票';
    } else if (stirng == '004') {
        return '纸质专票';
    } else if (stirng == '007') {
        return '纸质普票';
    } else if (stirng == '026') {
        return '电子普票';
    }
},

// 仟分位符
Vue.prototype.toThousands = function(number) {
    var val = ""
    var decimal = 2;
    var s = String(number);
    var decimalIndex = s.indexOf('.');
    if (decimalIndex < 0) {
        var fraction = '';
        for (var i = 0; i < decimal; i++) {
            fraction += '0';
        }
        val = s + '.' + fraction;
    }
    var numDigits = s.length - 1 - decimalIndex;
    if (numDigits <= decimal) {
        var fraction = '';
        for (var i = 0; i < decimal - numDigits; i++) {
            fraction += '0';
        }
        if(val==""){
            val = s + fraction;
        }
    }
    var digits = s.split('');
    var pos = decimalIndex + decimal;
    var roundDigit = digits[pos + 1];
    if (roundDigit > 4) {
      //跳过小数点
        if (pos == decimalIndex) {
            --pos;
        }
        digits[pos] = Number(digits[pos] || 0) + 1;
        //循环进位
        while (digits[pos] == 10) {
            digits[pos] = 0;
            --pos;
            if (pos == decimalIndex) {
                --pos;
            }
            digits[pos] = Number(digits[pos] || 0) + 1;
        }
    }
    //避免包含末尾的.符号
    if (decimal == 0) {
        decimal--;
    }
    if(val==""){
        val = digits.slice(0, decimalIndex + decimal + 1).join('')
    }
    return val.toString().replace(/\d+/, function(n) {
        return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
            return $1 + ",";
        });
    });
};

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
